class Form {
  theme = null;

  constructor(theme) {
    this.theme = theme;
    Form.instance = this;
  }

  static init(theme) {
    Form.instance = null;
    return new Form(theme);
  }

  getLabelStyle(width = "150px") {
    return {
      width,
      color: this.theme.palette.primary.greyPrimary,
      fontSize: this.theme.typography.customFontSize[2],
      fontWeight: this.theme.typography.customFontWeight[0],
    };
  }

  getHeaderTextStyle() {
    return {
      color: this.theme.palette.primary.main,
      fontFamily: this.theme.typography.fontFamily,
      fontSize: this.theme.typography.customFontSize[5],
      fontWeight: this.theme.typography.customFontWeight[3],
    };
  }

  getColumnHeaderStyle() {
    return {
      color: this.theme.palette.primary.main,
      fontFamily: this.theme.typography.fontFamily,
      fontSize: this.theme.typography.customFontSize[2],
      fontWeight: this.theme.typography.customFontWeight[1],
    };
  }

  getTextfieldStyle(isValid = true, width = "286px") {
    return {
      width,
      "& .MuiOutlinedInput-root": {
        borderRadius: this.theme.shape.customBorderRadius[1],
        height: "42px",
        backgroundColor: this.theme.palette.primary.transparent,
        color: this.theme.palette.primary.greyPrimary,
        fontSize: this.theme.typography.customFontSize[2],

        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: isValid
            ? this.theme.palette.primary.borderGreyPrimary
            : this.theme.palette.primary.redPrimary,
        },

        "&:hover .MuiOutlinedInput-notchedOutline": {
          borderColor: isValid
            ? this.theme.palette.primary.mainHover
            : this.theme.palette.primary.redPrimary,
        },

        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
          borderColor: isValid
            ? this.theme.palette.primary.main
            : this.theme.palette.primary.redPrimary,
        },
      },
      "& .MuiOutlinedInput-input": {
        color: this.theme.palette.primary.greyPrimary,
        fontSize: this.theme.typography.customFontSize[2],
        padding: "0 8px",
      },
    };
  }
}

export default Form;
